<div class="modal-header">
    <h4 class="modal-title">Override SRD Policy</h4>
</div>
<div class="modal-body">
    <div class="modal-body-inner">
        <div class="add-user-form">
            <p class="warning-message">You are about to override company SRD policy. This action may have downstream impacts. Proceed only if the deviation is essential and will not adversely affect operations.</p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="dark-bordered-btn dont-send-btn" (click)="cancel()">Cancel</button>
    <button type="button" class="submit-btn-grey status-modal-save" (click)="confirm()">Confirm</button>
</div>
